import axios from 'axios';
import alert_mixin from '@/utils/mixins/alert_mixin';
import BindSubEntities from '@/views/config_views/EntityManagement/CreateSubEntities/BindSubEntities.vue';
import BindTemplates from '@/views/config_views/TemplateManagement/BindTemplates/BindTemplates.vue';
import WorkflowBinding from '@/views/config_views/WorkflowManagement/WorkflowBinding/WorkflowBinding.vue';
import BindService from '@/views/config_views/AutoVerificationManagment/BindServices/BindServices.vue';
import { fetch_entity_type_workflows } from '@/services/workflow_service';
import {
  CREATE_ENTITY_CONFIG_URL,
  CREATE_FORM_BINDING_URL,
  CREATE_WORKFLOW_BINDING_URL,
  CREATE_RULE_BINDING_URL,
  GET_COMPLIANCE_RULES_URL,
  GET_FORMS_URL,
  GET_FULL_CONFIG_BY_ENTITY_TYPE_URL,
  REMOVE_FORM_BINDING_URL,
  REMOVE_WORKFLOW_BINDING_URL,
  REMOVE_RULE_BINDING_URL,
  VIEW_ENTITY_TYPE_URL,
  get_request_config
} from '@/utils/system_constants/constant.js';
import ManualVerificationBinding from "@/views/config_views/ManualVerification/ManualVerificationBinding/ManualVerificationBinding.vue";
export default {
  name: 'EntitySubsystemBindings',
  mixins: [alert_mixin],
  components: { BindTemplates, WorkflowBinding, BindService, BindSubEntities, ManualVerificationBinding },
  data: () => ({

      active_tab: 'forms',
      tabs: [
        { key: 'forms', label: 'Forms' },
        { key: 'template', label: 'Template' },
        { key: 'workflow', label: 'Workflow' },
        { key: 'rules', label: 'Rules' },
        { key: 'risk', label: 'Risk' },
        { key: 'auto_verification', label: 'Auto Verification' },
        { key: 'manual_verification', label: 'Manual Verification' },
        { key: 'children', label: 'Children' },
        { key: 'schema', label: 'Schema' },
        { key: 'history', label: 'History' }
      ],
      entity_type: {},
      entity_config: {},
      form_bindings: [],
      workflow_bindings: [],
      rule_bindings: [],
      available_forms: [],
      available_workflows: [],
      available_rules: [],
      selected_form_ids: [],
      form_dropdown_open: false,
      selected_workflow_id: '',
      selected_rule_ids: [],
      rule_dropdown_open: false,
      selected_priority: 0,
      creating_binding: false,
      creating_workflow_binding: false,
      creating_rule_binding: false
  }),
  computed: {
    entity_type_id() {
      return Number(this.$route.params.entityTypeId);
    },
    entity_type_name() {
      return (
        this.entity_type.entity_type_name ||
        this.entity_config.entity_type_name ||
        this.entity_config.entity_type?.entity_type_name ||
        'Entity'
      );
    },
    system_name() {
      return `ent_${String(this.entity_type_name || 'entity')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')}_v${this.entity_config.version || 1}`;
    },
    project_id() {
      return (
        this.entity_type.project_id ||
        this.entity_config.project_id ||
        this.entity_type.project?.id ||
        null
      );
    },
    bindable_forms() {
      const boundFormIds = new Set(
        (this.form_bindings || [])
          .map((binding) => Number(
            binding.form ||
            binding.form_id ||
            binding.form_template_id
          ))
          .filter((id) => Number.isFinite(id) && id > 0)
      );

      return (this.available_forms || []).filter(
        (form) => !boundFormIds.has(Number(form.id))
      );
    },
    bindable_rules() {
      const boundRuleIds = new Set(
        (this.rule_bindings || [])
          .map((binding) => Number(
            binding.compliance_rule ||
            binding.compliance_rule_id ||
            binding.compliance_rule?.id ||
            binding.rule_id ||
            binding.rule
          ))
          .filter((id) => Number.isFinite(id) && id > 0)
      );
      const boundRuleNames = new Set(
        (this.rule_bindings || [])
          .map((binding) => this.normalize_binding_name(
            binding.rule_name ||
            binding.name ||
            binding.compliance_rule_name ||
            binding.compliance_rule?.name
          ))
          .filter(Boolean)
      );

      return (this.available_rules || []).filter(
        (rule) => (
          !boundRuleIds.has(Number(rule.id)) &&
          !boundRuleNames.has(this.normalize_binding_name(rule.name))
        )
      );
    },
    bindable_workflows() {
      const boundWorkflowIds = new Set(
        (this.workflow_bindings || []).map((binding) => Number(
          binding.workflow
          || binding.entity_type_workflow
          || binding.workflow_id
          || binding.entity_type_workflow_id
        ))
      );

      return (this.available_workflows || []).filter(
        (workflow) => !boundWorkflowIds.has(Number(workflow.id))
      );
    },
    subsystem_metrics() {
      return [
        { label: 'Forms', value: this.form_bindings.length, icon: 'bi-file-earmark-text' },
        { label: 'Workflows', value: this.workflow_bindings.length, icon: 'bi-diagram-3' },
        { label: 'Rules', value: this.rule_bindings.length, icon: 'bi-sliders' }
      ];
    },
    selected_forms_count() {
      return Array.isArray(this.selected_form_ids) ? this.selected_form_ids.length : 0;
    },
    selected_rules_count() {
      return Array.isArray(this.selected_rule_ids) ? this.selected_rule_ids.length : 0;
    },
    selected_forms_label() {
      if (!this.bindable_forms.length) return 'No forms available';
      if (!this.selected_forms_count) return 'Select form(s) to bind';
      return `${this.selected_forms_count} form${this.selected_forms_count === 1 ? '' : 's'} selected`;
    },
    selected_rules_label() {
      if (!this.bindable_rules.length) return 'No unbound rules available';
      if (!this.selected_rules_count) return 'Select rule(s) to bind';
      return `${this.selected_rules_count} rule${this.selected_rules_count === 1 ? '' : 's'} selected`;
    }
  },
  mounted() {
    this.load_page();
    document.addEventListener('click', this.on_document_click, true);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.on_document_click, true);
  },
  methods: {
    on_document_click(event) {
      if (!this.form_dropdown_open && !this.rule_dropdown_open) return;

      const formRoot = this.$refs?.formMultiselect;
      if (this.form_dropdown_open && formRoot && !formRoot.contains(event.target)) {
        this.form_dropdown_open = false;
      }

      const ruleRoot = this.$refs?.ruleMultiselect;
      if (this.rule_dropdown_open && ruleRoot && !ruleRoot.contains(event.target)) {
        this.rule_dropdown_open = false;
      }
    },
    toggle_form_dropdown() {
      if (this.creating_binding) return;
      this.form_dropdown_open = !this.form_dropdown_open;
      if (this.form_dropdown_open) this.fetch_available_forms();
    },
    toggle_rule_dropdown() {
      if (this.creating_rule_binding) return;
      this.rule_dropdown_open = !this.rule_dropdown_open;
      if (this.rule_dropdown_open) this.fetch_available_rules();
    },
    normalize_binding_name(value) {
      return String(value || '').trim().toLowerCase();
    },

    parse_response_data(payload) {
      let result = payload;

      if (typeof payload === 'string') {
        const trimmedPayload = payload.trim();

        if (!trimmedPayload) {
          result = {};
        } else {
          try {
            result = JSON.parse(trimmedPayload);
          } catch {
            result = {};
          }
        }
      }

      return result;
    },

    async fetch_entity_type() {
      const response = await axios.get(
        VIEW_ENTITY_TYPE_URL,
        get_request_config({
          params: {
            entity_type_id: this.entity_type_id
          }
        })
      );

      const responseData = this.parse_response_data(response.data);
      const items = responseData.data || [];
      this.entity_type = Array.isArray(items)
        ? (items.find((item) => Number(item.id) === this.entity_type_id) || items[0] || {})
        : items;
    },

    async fetch_full_config() {
      const response = await axios.get(
        GET_FULL_CONFIG_BY_ENTITY_TYPE_URL,
        get_request_config({
          params: {
            entity_type_id: this.entity_type_id
          }
        })
      );

      const responseData = this.parse_response_data(response.data);
      return responseData.data || {};
    },

    ensure_entity_config_exists() {
      const promise = this.fetch_full_config().catch(async (error) => {
        if (error?.response?.status !== 404) {
          throw error;
        }

        await axios.post(
          CREATE_ENTITY_CONFIG_URL,
          { entity_type_id: this.entity_type_id },
          get_request_config()
        );

        const fetched = await this.fetch_full_config();
        return fetched;
      });

      return promise;
    },

    fetch_available_forms() {
      const result = axios
        .get(
          GET_FORMS_URL,
          get_request_config({
            params: this.project_id ? { project_id: this.project_id } : {}
          })
        )
        .then((response) => {
          const responseData = this.parse_response_data(response.data);
          const rawForms = responseData.data || responseData || [];

          this.available_forms = (Array.isArray(rawForms) ? rawForms : [])
            .map((form) => ({
              id: form.id || form.form_id,
              form_name: form.form_name || form.name || `Form ${form.id || form.form_id}`
            }))
            .filter((form) => form.id);

          const output = this.available_forms;
          return output;
        })
        .catch(() => {
          this.available_forms = [];
          const output = this.available_forms;
          return output;
        });

      return result;
    },

    async load_page() {
      const loader = await this.show_loader('Loading subsystem bindings...');

      try {
        await this.fetch_entity_type();
        const configData = await this.ensure_entity_config_exists();
        this.entity_config = configData.entity_config || {};
        this.form_bindings = configData.form_bindings || [];
        this.workflow_bindings = configData.workflow_bindings || [];
        this.rule_bindings = configData.rule_bindings || [];
        await this.fetch_available_forms();
        await this.fetch_available_workflows();
        await this.fetch_available_rules();
      } catch (error) {
        const responseData = this.parse_response_data(error?.response?.data || {});
        this.show_error(responseData.message || 'Failed to load subsystem bindings.');
      } finally {
        await this.close_loader(loader);
      }
    },

    describe_binding(binding) {
      return binding.priority === 0
        ? 'Captures base entity information and primary onboarding details.'
        : 'Supports secondary validation, compliance, or additional entity inputs.';
    },

    describe_rule_binding(binding) {
      return `${binding.logical_operator || 'AND'} logic${binding.rule_version ? ` · version ${binding.rule_version}` : ''}`;
    },

    get_binding_id(binding) {
      return Number(binding?.id);
    },

    get_workflow_binding_workflow_id(binding) {
      return Number(
        binding?.workflow
        || binding?.entity_type_workflow
        || binding?.workflow_id
        || binding?.entity_type_workflow_id
      );
    },

    should_keep_workflow_binding(item, target_binding) {
      const item_binding_id = this.get_binding_id(item);
      const target_binding_id = this.get_binding_id(target_binding);

      if (item_binding_id && target_binding_id) {
        return item_binding_id !== target_binding_id;
      }

      const item_workflow_id = this.get_workflow_binding_workflow_id(item);
      const target_workflow_id = this.get_workflow_binding_workflow_id(target_binding);

      if (item_workflow_id && target_workflow_id) {
        return item_workflow_id !== target_workflow_id;
      }

      return true;
    },

    async fetch_available_rules() {
      return axios.get(
        GET_COMPLIANCE_RULES_URL,
        get_request_config()
      )
        .then((response) => {
          const responseData = this.parse_response_data(response.data);
          const rawRules = responseData.rules || responseData.data || [];

          this.available_rules = (Array.isArray(rawRules) ? rawRules : [])
            .map((rule) => ({
              id: rule.id,
              name: rule.name || `Rule ${rule.id}`,
              description: rule.description || '',
              logical_operator: rule.logical_operator || 'AND',
              entity_type: rule.entity_type ?? null,
            }))
            .filter((rule) => rule.id)
            .filter((rule, index, rules) =>
              rules.findIndex((entry) => Number(entry.id) === Number(rule.id)) === index
            )
            .filter((rule, index, rules) =>
              rules.findIndex((entry) =>
                this.normalize_binding_name(entry.name) === this.normalize_binding_name(rule.name)
              ) === index
            );

          return this.available_rules;
        })
        .catch(() => {
          this.available_rules = [];
          return this.available_rules;
        });
    },

    async fetch_available_workflows() {
      try {
        const workflows = await fetch_entity_type_workflows();
        this.available_workflows = (Array.isArray(workflows) ? workflows : [])
          .map((workflow) => ({
            id: workflow.id,
            name: workflow.name || workflow.workflow_name || `Workflow ${workflow.id}`,
            description: workflow.description || '',
            status: workflow.workflow_status || workflow.status || 'NEW',
          }))
          .filter((workflow) => workflow.id);
      } catch (error) {
        this.available_workflows = [];
      }
    },

    format_rule_option(rule) {
      if (!rule) return '';
      const scope = rule.entity_type ? 'Scoped' : 'Global';
      return `${rule.name} (${scope})`;
    },

    async add_form_bindings() {
      const selected_ids = Array.isArray(this.selected_form_ids)
        ? this.selected_form_ids.map((id) => String(id)).filter(Boolean)
        : [];

      if (!selected_ids.length) {
        this.show_error('Please select at least one form to bind.');
        return;
      }

      this.creating_binding = true;

      try {
        const unique_ids = Array.from(new Set(selected_ids));
        const successes = [];
        const failures = [];
        const priority = Number(this.selected_priority) || 0;

        for (const raw_id of unique_ids) {
          const form_id = Number(raw_id);
          if (!Number.isFinite(form_id) || form_id <= 0) {
            failures.push({ form_id: raw_id, message: 'Invalid form selected.' });
            continue;
          }

          try {
            const response = await axios.post(
              CREATE_FORM_BINDING_URL,
              {
                entity_config_id: this.entity_config.id,
                form_id,
                priority
              },
              get_request_config()
            );

            const responseData = this.parse_response_data(response.data);
            const createdBinding = responseData.data;
            if (createdBinding) {
              this.form_bindings = this.sort_bindings([
                ...this.form_bindings.filter((item) => item.id !== createdBinding.id),
                createdBinding
              ]);
            } else {
              const configData = await this.fetch_full_config();
              this.form_bindings = configData.form_bindings || [];
            }

            successes.push(form_id);
          } catch (error) {
            const responseData = this.parse_response_data(error?.response?.data || {});
            failures.push({ form_id, message: responseData.message || 'Failed to create form binding.' });
          }
        }

        await this.fetch_available_forms();

        if (successes.length) {
          this.show_success(`${successes.length} form${successes.length === 1 ? '' : 's'} bound successfully.`);
        }

        if (failures.length) {
          this.show_error(
            failures.length === 1
              ? (failures[0]?.message || 'Failed to create form binding.')
              : `${failures.length} form${failures.length === 1 ? '' : 's'} failed to bind.`
          );
        }

        this.selected_form_ids = failures.map((failure) => String(failure.form_id)).filter(Boolean);
        if (!failures.length) this.selected_priority = 0;
        this.form_dropdown_open = false;
      } finally {
        this.creating_binding = false;
      }
    },

    async delete_form_binding(binding) {
      try {
        const response = await axios.post(
          REMOVE_FORM_BINDING_URL,
          { binding_id: binding.id },
          get_request_config()
        );
        const responseData = this.parse_response_data(response.data);
        this.form_bindings = this.form_bindings.filter((item) => item.id !== binding.id);
        await this.fetch_available_forms();
        this.show_success(responseData.message || 'Form binding removed.');
      } catch (error) {
        const responseData = this.parse_response_data(error?.response?.data || {});
        this.show_error(responseData.message || 'Failed to remove form binding.');
      }
    },

    remove_form_binding(binding) {
      this.show_confirm(
        'Remove Form Binding?',
        `Are you sure you want to remove ${binding.form_name || 'this form binding'}?`,
        () => this.delete_form_binding(binding)
      );
    },

    async add_workflow_binding() {
      if (!this.selected_workflow_id) {
        this.show_error('Please select a workflow to bind.');
        return;
      }

      this.creating_workflow_binding = true;

      try {
        const response = await axios.post(
          CREATE_WORKFLOW_BINDING_URL,
          {
            entity_config_id: this.entity_config.id,
            entity_type_workflow_id: Number(this.selected_workflow_id)
          },
          get_request_config()
        );

        const responseData = this.parse_response_data(response.data);
        const createdBinding = responseData.data;

        if (createdBinding) {
          this.workflow_bindings = [
            ...this.workflow_bindings.filter((item) => item.id !== createdBinding.id),
            createdBinding
          ];
        } else {
          const configData = await this.fetch_full_config();
          this.workflow_bindings = configData.workflow_bindings || [];
        }

        this.selected_workflow_id = '';
        await this.fetch_available_workflows();
        this.show_success(responseData.message || 'Workflow binding created successfully.');
      } catch (error) {
        const responseData = this.parse_response_data(error?.response?.data || {});
        this.show_error(responseData.message || 'Failed to create workflow binding.');
      } finally {
        this.creating_workflow_binding = false;
      }
    },

    async delete_workflow_binding(binding) {
      try {
        const response = await axios.post(
          REMOVE_WORKFLOW_BINDING_URL,
          { binding_id: binding.id },
          get_request_config()
        );
        const responseData = this.parse_response_data(response.data);
        this.workflow_bindings = this.workflow_bindings.filter((item) =>
          this.should_keep_workflow_binding(item, binding)
        );
        await this.fetch_available_workflows();
        this.show_success(responseData.message || 'Workflow binding removed.');
      } catch (error) {
        const responseData = this.parse_response_data(error?.response?.data || {});
        this.show_error(responseData.message || 'Failed to remove workflow binding.');
      }
    },

    async add_rule_bindings() {
      const selected_ids = Array.isArray(this.selected_rule_ids)
        ? this.selected_rule_ids.map((id) => String(id)).filter(Boolean)
        : [];

      if (!selected_ids.length) {
        this.show_error('Please select at least one rule to bind.');
        return;
      }

      this.creating_rule_binding = true;

      try {
        const unique_ids = Array.from(new Set(selected_ids));
        const successes = [];
        const failures = [];

        for (const raw_id of unique_ids) {
          const compliance_rule_id = Number(raw_id);
          if (!Number.isFinite(compliance_rule_id) || compliance_rule_id <= 0) {
            failures.push({ compliance_rule_id: raw_id, message: 'Invalid rule selected.' });
            continue;
          }

          try {
            const response = await axios.post(
              CREATE_RULE_BINDING_URL,
              {
                entity_config_id: this.entity_config.id,
                compliance_rule_id
              },
              get_request_config()
            );

            const responseData = this.parse_response_data(response.data);
            const createdBinding = responseData.data;
            if (createdBinding) {
              this.rule_bindings = [
                ...this.rule_bindings.filter((item) => item.id !== createdBinding.id),
                createdBinding
              ];
            } else {
              const configData = await this.fetch_full_config();
              this.rule_bindings = configData.rule_bindings || [];
            }

            successes.push(compliance_rule_id);
          } catch (error) {
            const responseData = this.parse_response_data(error?.response?.data || {});
            failures.push({ compliance_rule_id, message: responseData.message || 'Failed to create rule binding.' });
          }
        }

        await this.fetch_available_rules();

        if (successes.length) {
          this.show_success(`${successes.length} rule${successes.length === 1 ? '' : 's'} bound successfully.`);
        }

        if (failures.length) {
          this.show_error(
            failures.length === 1
              ? (failures[0]?.message || 'Failed to create rule binding.')
              : `${failures.length} rule${failures.length === 1 ? '' : 's'} failed to bind.`
          );
        }

        this.selected_rule_ids = failures.map((failure) => String(failure.compliance_rule_id)).filter(Boolean);
        this.rule_dropdown_open = false;
      } finally {
        this.creating_rule_binding = false;
      }
    },

    async delete_rule_binding(binding) {
      try {
        const response = await axios.post(
          REMOVE_RULE_BINDING_URL,
          { binding_id: binding.id },
          get_request_config()
        );
        const responseData = this.parse_response_data(response.data);
        this.rule_bindings = this.rule_bindings.filter((item) => item.id !== binding.id);
        await this.fetch_available_rules();
        this.show_success(responseData.message || 'Rule binding removed.');
      } catch (error) {
        const responseData = this.parse_response_data(error?.response?.data || {});
        this.show_error(responseData.message || 'Failed to remove rule binding.');
      }
    },

    remove_rule_binding(binding) {
      this.show_confirm(
        'Remove Rule Binding?',
        `Are you sure you want to remove ${binding.rule_name || 'this rule binding'}?`,
        () => this.delete_rule_binding(binding)
      );
    },

    sort_bindings(bindings) {
      return bindings.slice().sort((first, second) => {
        if ((first.priority || 0) !== (second.priority || 0)) {
          return (first.priority || 0) - (second.priority || 0);
        }
        return (first.id || 0) - (second.id || 0);
      });
    },

    go_to_entity_overview() {
      this.$router.push({
        name: 'EntityConfigDetail',
        params: {
          entityTypeId: this.entity_type_id
        }
      });
    },
    remove_workflow_binding(binding) {
      this.show_confirm(
        'Remove Workflow Binding?',
        `Are you sure you want to remove ${binding.workflow_name || binding.name || 'this workflow'}?`,
        () => this.delete_workflow_binding(binding)
      );
    }
  }
};
